import {
  getFirestore,
  collection,
  query,
  where,
  onSnapshot,
  doc,
  getDoc,
} from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

export const getUsers = async ({ state, commit, rootState }) => {
  const db = getFirestore();
  commit('SET_STATE', { key: 'isLoading', value: true });
  let q;
  if (rootState.auth.claims.superAdmin || rootState.auth.claims.eyeStaffAdmin) {
    q = query(collection(db, 'users'), where('role', 'in', ['superAdmin', 'eyeStaffAdmin', 'eyeStaff', 'orgAdmin', 'orgUser']));
  } else if (rootState.auth.claims.eyeStaff) {
    q = query(collection(db, 'users'), where('role', 'in', ['orgAdmin', 'orgUser', 'eyeStaff']));
  } else {
    const snapshotUser = await getDoc(doc(db, 'users', rootState.auth.providerLoginInfos.uid));
    const userData = snapshotUser.data();
    q = query(
      collection(db, 'users'),
      where('role', 'in', ['orgAdmin', 'orgUser']),
      where('organization', '==', userData.organization),
    );
  }
  onSnapshot(q, (snapshot) => {
    const users = [...state.users];
    const changes = snapshot.docChanges();
    changes.forEach((c) => {
      if (c.type === 'added') {
        const organization = c.doc.data().organization.id;
        users.push({ ...c.doc.data(), id: c.doc.id, organization });
      } else if (c.type === 'modified') {
        const userIndex = users.findIndex((s) => s.id === c.doc.id);
        if (userIndex !== -1) {
          const organization = c.doc.data().organization.id;
          users[userIndex] = {
            ...c.doc.data(),
            id: c.doc.id,
            organization,
          };
        }
      } else if (c.type === 'removed') {
        const userIndex = users.findIndex((s) => s.id === c.doc.id);
        if (userIndex !== -1) {
          users.splice(userIndex, 1);
        }
      }
    });
    commit('SET_STATE', { key: 'users', value: users });
    commit('SET_STATE', { key: 'isLoading', value: false });
    if (!state.isInitialized) commit('INITIALIZE');
  });
};

export const submitUser = async ({ commit }, { payload }) => {
  commit('SET_STATE', { key: 'isLoading', value: true });
  try {
    const functions = getFunctions();
    const createUser = httpsCallable(functions, 'createUser');
    const result = await createUser({
      ...payload,
    });
    if (result.data.isExists) {
      commit('SET_STATE', { key: 'error', value: 'Email address already exists.' });
    } else {
      commit('SET_STATE', { key: 'error', value: null });
    }
  } catch (error) {
    commit('SET_STATE', { key: 'error', value: error.message });
  } finally {
    commit('SET_STATE', { key: 'isLoading', value: false });
  }
};

export const deleteUser = async ({ commit }, { payload }) => {
  commit('SET_STATE', { key: 'isLoading', value: true });

  try {
    const functions = getFunctions();
    const deleteEyeUser = httpsCallable(functions, 'deleteUser');
    await deleteEyeUser({
      ...payload,
    });
  } catch (error) {
    commit('SET_STATE', { key: 'error', value: error.message });
  } finally {
    commit('SET_STATE', { key: 'isLoading', value: false });
  }
};

export const getOwnerList = async ({ state, commit, rootState }) => {
  const db = getFirestore();
  let ownerQuery;

  if (rootState.auth.claims.superAdmin || rootState.auth.claims.eyeStaffAdmin) {
    ownerQuery = query(collection(db, 'users'), where('role', 'in', ['superAdmin', 'eyeStaffAdmin', 'eyeStaff', 'orgAdmin', 'orgUser']));
  } else if (rootState.auth.claims.eyeStaff) {
    ownerQuery = query(collection(db, 'users'), where('role', 'in', ['orgAdmin', 'orgUser', 'eyeStaff']));
  } else {
    const snapshotUser = await getDoc(doc(db, 'users', rootState.auth.providerLoginInfos.uid));
    const userData = snapshotUser.data();
    ownerQuery = query(
      collection(db, 'users'),
      where('role', 'in', ['orgAdmin', 'orgUser']),
      where('organization', '==', userData.organization),
    );
  }
  onSnapshot(ownerQuery, (snapshot) => {
    const ownerList = [...state.ownerList];
    const changes = snapshot.docChanges();
    changes.forEach((c) => {
      if (c.type === 'added') {
        const organization = c.doc.data().organization?.id || null;
        ownerList.push({ ...c.doc.data(), id: c.doc.id, organization });
      } else if (c.type === 'modified') {
        const ownerIndex = ownerList.findIndex((s) => s.id === c.doc.id);
        if (ownerIndex !== -1) {
          const organization = c.doc.data().organization?.id || null;
          ownerList[ownerIndex] = {
            ...c.doc.data(),
            id: c.doc.id,
            organization,
          };
        }
      } else if (c.type === 'removed') {
        const ownerIndex = ownerList.findIndex((s) => s.id === c.doc.id);
        if (ownerIndex !== -1) {
          ownerList.splice(ownerIndex, 1);
        }
      }
    });
    commit('SET_STATE', { key: 'ownerList', value: ownerList });
    if (!state.isInitialized) commit('INITIALIZE');
  });
};

export const resetState = ({ commit }) => {
  commit('RESET_STATE');
};
